<template>
  <v-application>
    <v-card width="1000" class="ma-2">
      <v-card-text>
        <v-layout row class="ma-2">
          <v-flex md6 px-2>
            <v-select
              v-model="current_service"
              item-text="name"
              item-value="_id"
              :label="$t('store')"
              :items="services"
              ref="service"
              :rules="[fieldRules.required]"
              :disabled="items && items.length>0"
            ></v-select>
          </v-flex>
          <v-flex md6 px-2>
            <v-text-field
              v-if="single_price"
              v-model.number="price_percent"
              :label="$t('percent')"
              type="number"
              suffix="%"
              ref="percent"
              :rules="[fieldRules.require]"
            >
            </v-text-field>
            <v-layout v-else row>
              <v-flex md4 px-2>
                <v-text-field
                  v-model.number="price_percents[0]"
                  :label="$t('percent1')"
                  type="number"
                  suffix="%"
                ></v-text-field>
              </v-flex>
              <v-flex md4 px-2>
                <v-text-field
                  v-model.number="price_percents[1]"
                  :label="$t('percent2')"
                  type="number"
                  suffix="%"
                ></v-text-field>
              </v-flex>
              <v-flex md4 px-2>
                <v-text-field
                  v-model.number="price_percents[2]"
                  :label="$t('percent3')"
                  type="number"
                  suffix="%"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>

    <v-card width="1000" class="ma-2 mt-5">
      <v-card-title px-2>
        {{$t('items')}}
        <v-spacer />
        <v-checkbox v-model="is_round" :label="$t('round')"/>
        <v-btn text color="primary" @click="byDialog(1)">{{$t('add_by_category')}}</v-btn>
        <v-btn text color="primary" @click="byDialog(2)">{{$t('add_by_supplier')}}</v-btn>
      </v-card-title>
      <v-card-text>
        <v-data-table
          v-bind:headers="headers"
          disable-sort
          v-bind:items="items"
          hide-default-footer
          no-data-text="You have not selected items yet"
          :items-per-page="200000"
        >
          <template #[`item.name`]="{item}">
            <v-list-item-content style="width: 150px;">
              <v-list-item-title>{{item.name}}</v-list-item-title>
              <v-list-item-subtitle class="grey--text">SKU {{item.sku}}</v-list-item-subtitle>
              <v-list-item-subtitle v-if="item.barcode && item.barcode.length>0">
                Barcode
                <span v-for="(barcode, ind) in item.barcode" :key="ind">{{barcode+', '}}</span>
              </v-list-item-subtitle>
            </v-list-item-content>
          </template>
          <template #[`item.cost`]="{item}">
            <p class="ma-0 pa-0">{{item.cost?Math.round(item.cost).toLocaleString():item.cost}}</p>
          </template>
          <!-- single price -->
          <template #[`item.price`]="{item}">
            <p class="ma-0 pa-0">{{item.price?Math.round(item.price).toLocaleString():item.price}}</p>
          </template>
          <template #[`item.margin`]="{item}">
            <p class="ma-0 pa-0">{{(item.price && item.cost) ? Math.round((item.price-item.cost)/item.cost*100)+' %':''}}</p>
          </template>
          <template #[`item.price_next`]="{item}">
            <p class="ma-0 pa-0">{{price_percent && item.cost ? (Math.round(item.cost*(100+price_percent)/100/round_value)*round_value).toLocaleString() :''}}</p>
          </template>
          <template #[`item.margin_next`]="{}">
            <p class="ma-0 pa-0">
              {{price_percent+' %'}}
            </p>
          </template>
          <!-- multi price -->
          <!-- price1 -->
          <template #[`item.margin1`]="{item}">
            <v-list-item-content v-if="item.prices && item.prices[0]">
              <v-list-item-title>
                {{price_percents[0]+' %'}}
              </v-list-item-title>
              <v-list-item-subtitle style="color: #E2A80C" v-if="item.prices instanceof Array && item.prices.length > 0">
                {{(item.prices && item.prices[0].price && item.cost) ? Math.ceil((item.prices[0].price-item.cost)/item.cost*100)+' %':''}}
              </v-list-item-subtitle>
            </v-list-item-content>
          </template>

          <template #[`item.price1`]="{item}">
            <v-list-item-content v-if="item.prices && item.prices[0]">
              <v-list-item-title>
                {{item.cost ? (Math.round(item.cost*(100+price_percents[0])/100/round_value)*round_value).toLocaleString() :''}}
              </v-list-item-title>
              <v-list-item-subtitle style="color: #E2A80C" v-if="item.prices instanceof Array && item.prices.length > 0">
                {{item.prices && item.prices[0] && item.prices[0].price ? Math.round(item.prices[0].price).toLocaleString():''}}
              </v-list-item-subtitle>
            </v-list-item-content>
          </template>

          <!-- price2 -->
          <template #[`item.margin2`]="{item}">
            <v-list-item-content v-if="item.prices && item.prices[1]">
              <v-list-item-title>
                {{price_percents[1]+' %'}}
              </v-list-item-title>
              <v-list-item-subtitle style="color: #E2A80C" v-if="item.prices instanceof Array && item.prices.length > 1">
                {{(item.prices && item.prices[1] && item.prices[1].price && item.cost) ? Math.ceil((item.prices[1].price-item.cost)/item.cost*100)+' %':''}}
              </v-list-item-subtitle>
            </v-list-item-content>
          </template>

          <template #[`item.price2`]="{item}">
            <v-list-item-content v-if="item.prices && item.prices[1]">
              <v-list-item-title>
                {{item.cost ? (Math.round(item.cost*(100+price_percents[1])/100/round_value)*round_value).toLocaleString() :''}}
              </v-list-item-title>
              <v-list-item-subtitle style="color: #E2A80C" v-if="item.prices instanceof Array && item.prices.length > 1">
                {{item.prices && item.prices[1] && item.prices[1].price ? Math.round(item.prices[1].price).toLocaleString():''}}
              </v-list-item-subtitle>
            </v-list-item-content>
          </template>

          <!-- price3 -->
          <template #[`item.margin3`]="{item}">
            <v-list-item-content v-if="item.prices && item.prices[2]">
              <v-list-item-title>
                {{price_percents[2]+' %'}}
              </v-list-item-title>
              <v-list-item-subtitle style="color: #E2A80C" v-if="item.prices instanceof Array && item.prices.length > 2">
                {{(item.prices && item.prices[2] && item.prices[2].price && item.cost) ? Math.ceil((item.prices[2].price-item.cost)/item.cost*100)+' %':''}}
              </v-list-item-subtitle>
            </v-list-item-content>
          </template>

          <template #[`item.price3`]="{item}">
            <v-list-item-content v-if="item.prices && item.prices[2]">
              <v-list-item-title>
                {{item.cost ? (Math.round(item.cost*(100+price_percents[2])/100/round_value)*round_value).toLocaleString() :''}}
              </v-list-item-title>
              <v-list-item-subtitle style="color: #E2A80C" v-if="item.prices instanceof Array && item.prices.length > 2">
                {{item.prices && item.prices[2] && item.prices[2].price ? Math.round(item.prices[2].price).toLocaleString():''}}
              </v-list-item-subtitle>
            </v-list-item-content>
          </template>
          
          <template #[`item.remove`]="{item}">
            <v-btn icon v-on:click="remove_item(item)">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </template>
        </v-data-table>
        <v-divider />
        <v-card-text>          
          <v-search-items
            v-bind:label="$t('add_item')"
            v-bind:items="items_list"
            v-bind:selectedAct="add_item"
            v-bind:name_key="'name'"
            v-bind:rules="items&&items.length==0 ? [fieldRules.required] : []"
            v-bind:searchItems="getItems"
            v-bind:loading_inv_items="loading"
          ></v-search-items>
        </v-card-text>
      </v-card-text>
    </v-card>

    <v-card width="1000" class="ma-2 mt-5 mb-10" color="transparent" flat>
      <hr class="my-4" />
      <v-layout row mx-2 width="800">
        <hr />
        <v-flex md12>
          <v-layout row>
            <v-spacer />
            <v-btn tile class="mx-4" @click="cancelClicked">{{$t('cancel')}}</v-btn>
            <v-btn tile color="primary" ml-2 :disabled="createDisabled || send_request" @click="createPricing">{{$t('update_prices')}}</v-btn>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-card>
    <v-snackbar
      v-model="snackbar"
      right
      top
      :timeout="3000"
      color="red"
    >Unable to create labels. Please fix the errors and try again.</v-snackbar>
    <v-dialog v-model="dialog" persistent width="500">
      <v-card>
        <v-card-text class="pa-5 black--text">This item has already been added</v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialog = false">ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="by_dialog" persistent width="600">
      <v-card tile>
        <v-card-title>{{by_dialog_items.title}}</v-card-title>
        <hr style="border: 0.5px dashed grey" />
        <v-layout row mx-4>
          <v-text-field
            v-model="search_item"
            autocomplete="off"
            color="black"
            placeholder="Search"
            @input="searchItems"
            prepend-icon="mdi-magnify"
            :loading="data_loading"
          ></v-text-field>
        </v-layout>

        <hr style="border: 0.5px dashed grey" class="mt-0" />
        <v-card-text class="py-2 px-4">
          <v-layout row v-for="(itm, ind) in by_dialog_items.items" :key="ind">
            <v-flex md12 px-4>
              <v-layout>
                <v-flex md12>
                  <v-checkbox :label="itm.name" v-model="by_dialog_items.selected[ind]"></v-checkbox>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex md12>
                  <hr
                    v-if="by_dialog_items.items.length-1 != ind"
                    style="border: 0.5px dashed grey"
                    class="mt-0"
                  />
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card-text>

        <hr v-if="by_dialog_items.items.length > 0" style="border: 0.5px dashed grey" class="mt-0" />
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="by_dialog = false">Cancel</v-btn>
          <v-btn text color="primary" @click="addItem">Add</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-application>
</template>
<script>
import Services from "../../mixins/services";
export default {
  name: "Items",
  mixins: [Services],
  data: () => ({
    print_name: true,
    single_price: true,
    print_price: true,
    price_percent: 0,
    price_percents: [0, 0, 0],
    dialog: false,
    by_dialog: false,
    by_dialog_items: {
      title: "Add items by category",
      items: [],
      old_items: [],
      selected: [],
    },
    default_type: 4,
    data_loading: false,
    snackbar: false,
    headers: [
      { text: "Item", value: "name", align: "left" },
      { text: 'Cost', value: 'cost', align: 'right' },
      { text: 'Margin', value: 'margin', align: 'right' },
      { text: 'Price', value: 'price', align: 'right' },
      { text: 'Margin next', value: 'margin_next', align: 'right' },
      { text: 'Price next', value: 'price_next', align: 'right' },
      { text: null, value: "remove", align: "right", width: 50 },
    ],
    rules: {
      required: (value) => !!value || "",
    },
    data: [],
    stocks: [
      { text: "All items", value: "all" },
      { text: "Low stock", value: "low" },
      { text: "Out of stock", value: "out" },
    ],
    stock: null,
    page: 1,
    loading: false,
    numPages: 1,
    total: 0,
    items: [],
    item: {},
    items_list: [],
    current_type: "sku",
    current_type_id: 1,
    current_service: null,
    types: ["sku", "barcode"],
    search_item: "",
    err: null,
    send_request: false,
    search_text: '123',
    is_round: false,
    round_value: 1
  }),
  watch: {
    is_round() {
      if(this.is_round) {
        this.round_value = 100
      }
      else {
        this.round_value = 1
      }
    },
    services() {
      if (this.services && this.services.length > 0) {
        if(this.target == 'pricing'){
          this.current_service = this.services[0]._id;
        }
      }
    },
    current_service() {
      this.getItems('', true);
    },
    single_price() {
      if(this.single_price) {
        this.headers = [
          { text: this.$t("item"), value: "name", align: "left" },
          { text: this.$t('cost'), value: 'cost', align: 'right' },
          { text: this.$t('margin'), value: 'margin', align: 'right' },
          { text: this.$t('price'), value: 'price', align: 'right' },
          { text: this.$t('margin_next'), value: 'margin_next', align: 'right' },
          { text: this.$t('price_next'), value: 'price_next', align: 'right' },
          { text: null, value: "remove", align: "right", width: 50 },
        ]
      }
      else {
        this.headers = [
          { text: this.$t("item"), value: "name", align: "left" },
          { text: this.$t('cost'), value: 'cost', align: 'right' },
          { text: this.$t('margin1'), value: 'margin1', align: 'right' },
          { text: this.$t('price1'), value: 'price1', align: 'right' },
          { text: this.$t('margin2'), value: 'margin2', align: 'right' },
          { text: this.$t('price2'), value: 'price2', align: 'right' },
          { text: this.$t('margin3'), value: 'margin3', align: 'right' },
          { text: this.$t('price3'), value: 'price3', align: 'right' },
          { text: null, value: "remove", align: "right", width: 50 },
        ]
      }
    }
  },
  computed: {
    query() {
      return this.$route.query
    },
    target() {
      return this.$route.params["target"];
    },
    form() {
      return {
        service: this.current_service,
        percent: this.price_percent
      }
    },
    createDisabled() {
      let formHasErrors = false || (this.items && this.items.length == 0);
      delete this.form.percent
      Object.keys(this.form).forEach((f) => {
        if (!this.form[f]) formHasErrors = true;
      });
      return formHasErrors;
    }
  },
  methods: {
    searchItems() {
      var items = [];
      for (let i = 0; i < this.by_dialog_items.old_items.length; i++) {
        if (
          new RegExp(this.search_item.trim(" "), "ig").exec(
            this.by_dialog_items.old_items[i].name
          )
        ) {
          items.push(this.by_dialog_items.old_items[i]);
        }
      }
      this.by_dialog_items.items = items;
    },
    async addItem() {
      var categories = [];
      for (let i = 0; i < this.by_dialog_items.selected.length; i++) {
        if (this.by_dialog_items.selected[i]) {
          categories.push(this.by_dialog_items.items[i]._id);
        }
      }
      var params = {
        categories: categories,
      };
      if (this.current_type_id == 2) {
        params = {
          suppliers: categories,
        };
      }
      const items = this.$communicator.then(
        this,
        await this.$communicator("list_of_items", {
          params: {
            ...params,
            service: this.current_service ? this.current_service : "",
          },
        })
      );
      for (let j = 0; j < items.length; j++) {
        var has = false;
        for (let i = 0; i < this.items.length; i++) {
          if (items[j]._id == this.items[i]._id) {
            has = true;
          }
        }
        if (!has) {
          items[j].quality = 1;
          this.items.push(this.$copy(items[j]));
        }
      }
      this.by_dialog = false;
    },
    async byDialog(ind) {
      this.current_type_id = ind;
      this.data_loading = true;
      if (ind == 1) {
        try {
          this.by_dialog_items.items = (
            await this.$communicator("list_of_categories")
          ).data.data;
          this.by_dialog_items.old_items = this.by_dialog_items.items;
        } catch (err) {
          this.err = err;
        }
        this.by_dialog_items.title = "Add items by category";
      } else {
        try {
          var items = (await this.$communicator("all_suppliers")).data.data;
          for (let i = 0; i < items.length; i++) {
            items[i].name = items[i].supplier_name;
          }
          this.by_dialog_items.items = items;
          this.by_dialog_items.old_items = this.by_dialog_items.items;
        } catch (err) {
          this.err = err;
        }
        this.by_dialog_items.title = "Add items by supplier";
      }
      this.by_dialog = true;
      this.data_loading = false;
    },
    cancelClicked() {
      this.$router.push("/items/list");
    },
    async createPricing() {
      this.send_request=true
      const ids = []
      for(const itm of this.items) {
        ids.push(itm._id)
      }
      const res = this.$communicator.then(
        this,
        await this.$communicator("update_items_prices", {
          params: {
            percent: this.price_percent,
            service: this.current_service,
            percents: this.price_percents,
            is_round: this.is_round,
            indexes: ids
          }
        })
      )
      if(res) {
        this.$router.push('/items/list').catch(()=>{})
      }
      this.send_request=false
    },
    add_item(item) {
      var has_account = false;
      for (let i = 0; i < this.items.length; i++) {
        if (item._id == this.items[i]._id) {
          has_account = true;
        }
      }
      if (has_account) {
        this.dialog = true;
      } else {
        this.items.push(this.$copy(item));
      }
    },
    remove_item(item) {
      const index = this.items.indexOf(item);
      this.items.splice(index, 1);
    },
    changePagination(page) {
      this.page = page;
      this.update_items();
    },
    async remove(items) {
      var indices = [];
      for (const index in items) {
        indices.push(items[index]._id);
      }
      await this.$communicator("remove_items", {
        params: {
          indexes: indices,
        },
      });
      this.update_items();
    },
    async getItems(search, service_change) {
      if(!this.current_service) {
        return
      }
      if(typeof search != typeof 'invan') {
        search = ''
      }
      if(this.search_text == search && !service_change) {
        return
      }
      this.search_text = search
      this.loading = true;
      const res = this.$communicator.then(
        this,
        await this.$communicator("list_of_items", {
          arguments: [20, 1],
          params: {
            service: this.current_service ? this.current_service : "",
            search: search
          },
        })
      );
      let items_list = []
      if(res && res.data && res.data.length>0) {
        items_list = res.data
      }
      const itemsMap = {};
      const item_list=[]
      for(const item of items_list) {
        itemsMap[item._id] = item
        let search_text = item.name + this.converter(item.name) + item.sku
        if(item.barcode instanceof Array) {
          for(const b of item.barcode) {
            search_text+=b
          }
        }
        item_list.push({
          ...item,
          search_text: search_text
        })
      }
      this.items_list = item_list
      for(const index in this.items) {
        if(itemsMap[this.items[index]._id]) {
          this.items[index].price = itemsMap[this.items[index]._id].price
        }
      }
      
      this.loading = false;
    },
    async getAccess() {
      const access = this.$communicator.then(
        this,
        await this.$communicator("get_access")
      );
      if(access && access.feature && access.feature.prices) {
        this.single_price = false
      }
      else {
        this.single_price = true
      }
    },
    async checkQuery() {
      if(this.query) {
        if(this.query.purchase != undefined) {
          const data = this.$communicator.then(
            this,
            await this.$communicator("purchase_by_id", {
              arguments: [this.query.purchase],
            })
          );
          if(data && data.items instanceof Array) {
            const items = []
            const exist = {}
            for(const item of data.items) {
              if(exist[item.product_id] == undefined) {
                exist[item.product_id] = items.length
                items.push({
                  _id: item.product_id,
                  name: item.product_name,
                  sku: item.sku,
                  barcode: item.barcode,
                  quality: item.quality,
                  price: item.price,
                  cost: item.cost
                })
              }
              else {
                items[exist[item.product_id]].quality += item.quality
              }
            }
            this.items = items
            this.current_service = data.service
          }
        }
        else if(this.query.transfer != undefined) {
          const transfer = this.$communicator.then(
            this,
            await this.$communicator("transfer", {
              arguments: [this.query.transfer],
            })
          );
          if(transfer && transfer.items instanceof Array) {
            const items = []
            const exist = {}
            for(const item of transfer.items) {
              if(exist[item.product_id] == undefined) {
                exist[item.product_id] = items.length
                items.push({
                  _id: item.product_id,
                  name: item.product_name,
                  sku: item.sku,
                  barcode: item.barcode,
                  quality: item.quality,
                  price: item.price,
                  cost: item.cost
                })
              }
              else {
                items[exist[item.product_id]].quality += item.quality
              }
            }
            this.items = items
            this.current_service = transfer.second_service
          }
        }
        else if(this.query.stock != undefined) {
          const stock = this.$communicator.then(
            this,
            await this.$communicator("stock_by_id", {
              arguments: [this.query.stock],
            })
          );
          if(stock && stock.items instanceof Array) {
            const items = []
            const exist = {}
            for(const item of stock.items) {
              if(exist[item.product_id] == undefined) {
                exist[item.product_id] = items.length
                items.push({
                  _id: item.product_id,
                  name: item.product_name,
                  sku: item.sku,
                  barcode: item.barcode,
                  quality: item.changed,
                  price: item.price,
                  cost: item.cost
                })
              }
              else {
                items[exist[item.product_id]].quality += item.quality
              }
            }
            this.items = items
            this.current_service = stock.service
          }
        }
        else if(this.query.production != undefined) {
          const production = this.$communicator.then(
            this,
            await this.$communicator("production_by_id", {
              arguments: [this.query.production],
            })
          );
          if(production && production.items instanceof Array) {
            const items = []
            const exist = {}
            for(const item of production.items) {
              if(exist[item.product_id] == undefined) {
                exist[item.product_id] = items.length
                items.push({
                  _id: item.product_id,
                  name: item.product_name,
                  sku: item.sku,
                  barcode: item.barcode,
                  quality: item.quality,
                  price: item.price,
                  cost: item.cost
                })
              }
              else {
                items[exist[item.product_id]].quality += item.quality
              }
            }
            this.items = items
            this.current_service = production.service
          }
        }
      }
      this.refreshItems()
    },
    async refreshItems() {
      const ids = []
      for(const itm of this.items) {
        ids.push(itm._id)
      }
      const items = this.$communicator.then(
        this,
        await this.$communicator('inv_items_refresh', {
          params: {
            service: this.current_service,
            indexes: ids
          }
        })
      )
      if(items instanceof Array) {
        const ITEMS = []
        const resMap = {}
        for(const it of items) {
          resMap[it._id] = it
        }
        for(const it of this.items) {
          if(resMap[it._id]) {
            ITEMS.push({
              ...it,
              prices: resMap[it._id].prices
            })
          }
        }
        this.items = ITEMS
      }
    }
  },
  async mounted() {
    for (const index in this.headers) {
      this.headers[index]["sortable"] = false;
    }
    this.stock = this.stocks[0];
    await this.checkQuery()
    this.getAccess()
    this.getItems();
  },
};
</script>
